import { useState } from 'react'
import { restConfig } from '../authConfig'
import {
  CreateIntegrationSigningCredentialModel,
  IntegrationSigningCredentialModel
} from '../redux/types'
import useFetchClient from './useFetchClient'

const useIntegrationSigningCredentialActions = () => {
  const fetchClient = useFetchClient()
  const [credentials, setCredentials] = useState<IntegrationSigningCredentialModel[]>([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<Error | string | null>(null)

  const getCredentials = (customerId: string) => {
    setLoading(true)
    setError(null)
    const url = `${restConfig.routes.customers}/${customerId}/integrationsigningcredentials`

    return fetchClient.get(url)
      .then(response => {
        setCredentials(response.data as IntegrationSigningCredentialModel[])
        setLoading(false)
      })
      .catch(error => {
        console.log('getIntegrationSigningCredentials error:', error)
        setError(error)
        setLoading(false)
      })
  }

  const createCredential = (customerId: string, model: CreateIntegrationSigningCredentialModel) => {
    setLoading(true)
    setError(null)
    const url = `${restConfig.routes.customers}/${customerId}/integrationsigningcredentials`

    return fetchClient.post(url, model)
      .then(response => {
        setCredentials(current => [response.data as IntegrationSigningCredentialModel, ...current])
        setLoading(false)
      })
      .catch(error => {
        console.log('createIntegrationSigningCredential error:', error)
        setError(error)
        setLoading(false)
      })
  }

  const revokeCredential = (customerId: string, credentialId: string) => {
    setLoading(true)
    setError(null)
    const url = `${restConfig.routes.customers}/${customerId}/integrationsigningcredentials/${credentialId}`

    return fetchClient.delete(url)
      .then(() => {
        setCredentials(current => current.map(item =>
          item.id === credentialId ? { ...item, revokedAt: new Date().toISOString() } : item))
        setLoading(false)
      })
      .catch(error => {
        console.log('revokeIntegrationSigningCredential error:', error)
        setError(error)
        setLoading(false)
      })
  }

  return {
    credentials,
    loading,
    error,
    getCredentials,
    createCredential,
    revokeCredential
  }
}

export default useIntegrationSigningCredentialActions
